// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"d6ff93ee214d2b94","4467":"1e17706bc4ac3e79"}[chunkId] + ".css";
};